import { useTranslations } from 'next-intl'

import { Dialog } from '@/shared/ui'
import { AvailableWeekCalendar } from '@/widgets/contract-calendar'

type Props = {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  roomId: number
  startDate?: Date
  onSelect: (date?: Date) => void
}

export const EndDateCalendarDialog = ({
  isOpen,
  onOpenChange,
  roomId,
  startDate,
  onSelect,
}: Props) => {
  const t = useTranslations('guest_lease_list.dialog.extend_contract')

  return (
    <Dialog.Root open={isOpen} onOpenChange={onOpenChange}>
      <Dialog.Content className="gap-0 p-0">
        <Dialog.Header>
          <Dialog.Title className="sr-only">{t('title')}</Dialog.Title>
        </Dialog.Header>
        <AvailableWeekCalendar
          isExtend
          roomId={roomId}
          startDate={startDate}
          onSelect={onSelect}
        />
      </Dialog.Content>
    </Dialog.Root>
  )
}
